
export default class ErrorCode {

    static OK = 0;
    //
    static GENERAL_ERROR = 100001; 
    static NOT_IMPLEMENTED_EXCEPTION = 100010;
    static RECORD_NOT_FOUND_EXCEPTION = 100011;
    static INVALID_PARAMS_EXCEPTION = 100012;
    static ILLEGAL_STATE_EXCEPTION = 100013;
    static CLASS_CAST_EXCEPTION = 100013;
}
